/* Mobile PDP gallery: the image column becomes a snap carousel with a thumbnail
   strip beneath it.

   The thumbs are built FROM the gallery's live children rather than from Liquid,
   because selecting a colour makes mt-core.js re-order those children (it hoists
   the chosen colour's photo into first place). A MutationObserver rebuilds the
   strip whenever that happens, so thumbs and slides can never drift apart. */
(function () {
  var MQ = window.matchMedia('(max-width: 989px)');

  function init() {
    var gallery = document.querySelector('.cx-pdp__gallery');
    var strip = document.querySelector('[data-cx-thumbs]');
    if (!gallery || !strip) return;

    function slides() {
      return Array.prototype.slice.call(gallery.querySelectorAll('img'));
    }

    /* Horizontal offset of a slide inside the scroller. */
    function offsetWithin(img) {
      return gallery.scrollLeft
        + (img.getBoundingClientRect().left - gallery.getBoundingClientRect().left);
    }

    function build() {
      strip.innerHTML = '';
      slides().forEach(function (img, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cx-thumb' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'View image ' + (i + 1));
        var t = document.createElement('img');
        // reuse the already-decoded source; the browser serves it from cache
        t.src = img.currentSrc || img.src;
        t.alt = '';
        t.loading = 'lazy';
        b.appendChild(t);
        b.addEventListener('click', function () {
          // offsetLeft is relative to the offset parent, not the gallery, so measure
          // with rects. behavior:'smooth' is deliberately NOT used — Chromium cancels
          // a smooth scroll inside a `scroll-snap-type: mandatory` scroller and the
          // scroller stays at 0.
          gallery.scrollTo({ left: offsetWithin(img), behavior: 'auto' });
          markActive();
        });
        strip.appendChild(b);
      });
      strip.hidden = strip.children.length < 2;
    }

    function markActive() {
      var kids = slides();
      if (!kids.length) return;
      var mid = gallery.scrollLeft + gallery.clientWidth / 2;
      var idx = 0;
      kids.forEach(function (img, i) {
        if (offsetWithin(img) < mid) idx = i;
      });
      Array.prototype.forEach.call(strip.children, function (b, i) {
        b.classList.toggle('is-active', i === idx);
      });
    }

    build();

    var t = null;
    gallery.addEventListener('scroll', function () {
      if (t) cancelAnimationFrame(t);
      t = requestAnimationFrame(markActive);
    }, { passive: true });

    // swatch selection re-orders the gallery; keep the strip in step
    new MutationObserver(function () {
      build();
      gallery.scrollLeft = 0;
      markActive();
    }).observe(gallery, { childList: true });
  }

  function boot() {
    if (MQ.matches) init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // a rotate from portrait to landscape can cross the breakpoint
  (MQ.addEventListener ? MQ.addEventListener.bind(MQ, 'change') : MQ.addListener.bind(MQ))(function (e) {
    if (e.matches) init();
  });
})();
